import { render } from "./LocatorView.vue?vue&type=template&id=27809f98&scoped=true&ts=true"
import script from "./LocatorView.vue?vue&type=script&lang=ts"
export * from "./LocatorView.vue?vue&type=script&lang=ts"

import "./LocatorView.vue?vue&type=style&index=0&id=27809f98&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27809f98"]])

export default __exports__